import { render, staticRenderFns } from "./tabZfdetails4.vue?vue&type=template&id=4bb67675&"
import script from "./tabZfdetails4.vue?vue&type=script&lang=js&"
export * from "./tabZfdetails4.vue?vue&type=script&lang=js&"
import style0 from "./tabZfdetails4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports